import { all, fork, put,takeEvery, call, delay }  from "redux-saga/effects"
import * as actionTypes from "appRedux/actions/expected/ExpectedArrivalActionType"
import * as actionCreators from "appRedux/actions/expected/ExpectedArrival"
import { userSignOut} from "appRedux/actions/Auth"
import { API_URL_V1,API_PMS_HEADERS } from "constants/ApiSetting"
import dayjs from 'dayjs'
import { APIGetRequest } from "util/connection"
import { getItems } from "util/localStorage"
import { ApiResponse } from "constants/ActionTypes"

function* expectedArrivalRequestProcess({ payload }: actionTypes.ExpectedArrivalRequest) {

    let keywords = payload
    const reservationInfo = {} as any
    if(keywords.searchText)
      reservationInfo.search_text = keywords.searchText
    if(keywords.arrival)
      reservationInfo.arrival = dayjs(keywords.arrival).format('YYYY-MM-DD')
    if(keywords.departure)
      reservationInfo.departure = dayjs(keywords.departure).format('YYYY-MM-DD')
    if(keywords.stayDate)
      reservationInfo.stay_date = dayjs(keywords.stayDate).format('YYYY-MM-DD')
    if(keywords.roomNumber)
      reservationInfo.room_number= keywords.roomNumber
    if(keywords.roomTypeId)
      reservationInfo.roomtype_id= keywords.roomTypeId
    if(keywords.channelName)
      reservationInfo.channel_name= keywords.channelName
    if(keywords.vipId)
      reservationInfo.vip_id= keywords.vipId
    if(keywords.memberCode)
      reservationInfo.member_code= keywords.memberCode
    if(keywords.company)
      reservationInfo.company= keywords.company
    if(keywords.nationId)
      reservationInfo.nation_id= keywords.nationId
    if(keywords.ratePlanId)
      reservationInfo.rateplan_id= keywords.ratePlanId

    //.page = payload.current
    //reservationInfo.limit = payload.limit

    /* Create query string from array object */
    let queryString = Object.keys(reservationInfo).map(key =>`${key}=${reservationInfo[key]}`).join('&')

    const  { access_token }  = yield call(getItems, ['access_token'])
    const AccessToken = access_token
    const url = `${API_URL_V1}pms/registration/expectedArrival/?${queryString}`
    API_PMS_HEADERS.headers.Authorization = `Bearer ${AccessToken}`

    try {
        const response:ApiResponse = yield APIGetRequest(url,API_PMS_HEADERS)
        if(response.status === 200)
        {      
                const expectArrivalInfo = response.data
                /* if no error put everything to reducer */
                yield put(actionCreators.expectedArrivalDataSourceSuccess(expectArrivalInfo))
                yield delay(100)
                yield put(actionCreators.expectedArrivalSetFilter({...payload}))
                yield delay(100) 

        }else{
                /* Show error message and signout */
                const {message,data} = response.data
                const processStatus = { status: false, action: "preview", message}
                yield put(actionCreators.expectedArrivalProcessSuccess(processStatus))
                yield delay(100)
                if(response.status === 403){
                //if data is not null force signout 
                  if(data)
                      yield put(userSignOut())
                }
                
        }
    } catch (error) {
        const processStatus = { status: false, action: "preview", message:error}
        yield put(actionCreators.expectedArrivalProcessSuccess(processStatus))
        yield delay(100)
    }
}

function* expectedArrivalRequest() {
  yield takeEvery(actionTypes.EXPECTED_ARRIVAL_REQUEST, expectedArrivalRequestProcess)
}


export default function* rootSaga() {
  yield all([fork(expectedArrivalRequest)
  ])
}


